import type { LegalPageProps as Props } from './types';
import { cls } from '@/utils/cls';
import style from './LegalPage.module.scss';
import RichText from '../RichText';
export default function LegalPage({
  extendStyles,
  text
}: Props) {
  const _className = cls(style.root, extendStyles);
  return <div className={_className} data-sentry-component="LegalPage" data-sentry-source-file="LegalPage.tsx">
			<RichText text={text} className={style.wrapper} data-sentry-element="RichText" data-sentry-source-file="LegalPage.tsx" />
		</div>;
}